import React from 'react';

import { FLEET } from '../Pages';

export default {
  path: FLEET.pageURL,
  async action() {
    const { default: FleetList } = await import('./FleetList');
    return <FleetList key={'list'} />;
  },
};
